import React, {
  createContext,
  ReactNode,
  RefObject,
  useContext,
  useState,
} from 'react';
import { FloatingScrollBarState } from './FloatingScrollBarState';

class FloatingScrollBarContextValue {
  viewportRef = undefined as
    | undefined
    | {
        current: HTMLElement | null;
      };
  scrollableContentRef = {
    current: null as HTMLElement | null,
  };
  scrollElementRef = {
    current: null as HTMLElement | null,
  };
  floatingScrollBarStateRef = {
    current: null as FloatingScrollBarState | null,
  };
}

export const FloatingScrollBarContext = createContext(
  new FloatingScrollBarContextValue(),
);

export const useFloatingScrollBarContext = () =>
  useContext(FloatingScrollBarContext);

export function FloatingScrollBarContextProvider({
  children,
  scrollableContentRef,
  viewportRef,
  scrollElementRef,
}: {
  children: ReactNode;
  viewportRef?: RefObject<HTMLElement>;
  scrollableContentRef: RefObject<HTMLElement>;
  scrollElementRef: RefObject<HTMLElement>;
}) {
  const [value] = useState(() => new FloatingScrollBarContextValue());

  value.viewportRef = viewportRef;
  value.scrollableContentRef = scrollableContentRef;
  value.scrollElementRef = scrollElementRef;

  return (
    <FloatingScrollBarContext.Provider value={value}>
      {children}
    </FloatingScrollBarContext.Provider>
  );
}
